import { render } from "./SupplierDetailTabsPanel.vue?vue&type=template&id=425fd4dc"
import script from "./SupplierDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./SupplierDetailTabsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__